module.exports = __webpack_public_path__ + "static/nove-slichowice-be3b9c23d4aaf4c2662784e62d0a56d8.png";